export default "__VITE_ASSET__DWkEEehm__"